import PRODUCT_FEATURES from './productFeatures'
import { FAQs } from '../footerLinks'
import {
  Welcome,
  Registration,
  Summary,
  Family,
  Eligibility,
} from '@/types/partnerConfig'

interface LocalisedStep<T> {
  [key: string]: T
}

const WELCOME: LocalisedStep<Welcome> = {
  enUS: {
    title: 'Welcome to Babylon',
    stepperLabel: 'Welcome',
    copy: (planName: string) => [
      `Get health care anytime on your phone at no cost through ${planName}. Data rates may apply.`,
    ],
    productFeatures: PRODUCT_FEATURES.enUS,
  },
  esUS: {
    title: 'Bienvenido/a a Babylon',
    stepperLabel: 'Bienvenido',
    copy: (planName: string) => [
      `Obtenga atención médica gratuita en cualquier momento usando su teléfono a través de ${planName}. Pueden aplicarse tarifas por datos.`,
    ],
    productFeatures: PRODUCT_FEATURES.esUS,
  },
}

const REGISTRATION: LocalisedStep<Registration> = {
  enUS: {
    title: 'Register',
    stepperLabel: 'Registration',
    copy: ['Enter your details to access services through the Babylon app.'],
  },
  esUS: {
    title: 'Registrarse',
    stepperLabel: 'Registrarse',
    copy: [
      'Ingrese su información para acceder a los servicios a través de la aplicación de Babylon.',
    ],
  },
}

const FAMILY: LocalisedStep<Family> = {
  enUS: {
    title: 'Add Family Members',
    stepperLabel: 'Family',
    copy: [
      'Add your family members so they can have access to Babylon’s services',
    ],
  },
  esUS: {
    title: 'Agregue a los miembros de su familia',
    stepperLabel: 'Familia',
    copy: [
      'Agregue a los miembros de su familia para que tengan acceso a los servicios de Babylon',
    ],
  },
}

const ELIGIBILITY: LocalisedStep<Eligibility> = {
  enUS: {
    stepperLabel: 'Eligibility',
  },
  esUS: {
    stepperLabel: 'Elegibilidad',
  },
}

const SUMMARY: LocalisedStep<Summary> = {
  enUS: {
    title: 'Download the app',
    stepperLabel: 'Thank You',
    copy: [
      'Download and sign in to book a video appointment at no cost through your health plan.',
    ],
    imgUrl: '/images/babylon-ios-app.png',
    dnaV2DesignImgUrl: '/images/babylon-ios-app-us.png',
    cta: {
      showDownloadButtons: true,
      label: 'Questions? Contact us →',
      link: FAQs.USA,
    },
  },
  esUS: {
    title: 'Descargar la aplicación',
    stepperLabel: 'Descargar la aplicación',
    copy: [
      'Descargar e iniciar sesión para programar una cita por video sin costo a través de su plan médico.',
    ],
    imgUrl: '/images/babylon-ios-app.png',
    dnaV2DesignImgUrl: '/images/babylon-ios-app-us.png',
    cta: {
      showDownloadButtons: true,
      label: '¿Tiene preguntas? Comuníquese con nosotros →',
      link: FAQs.USA,
    },
  },
}

const premadeContent = {
  WELCOME,
  REGISTRATION,
  FAMILY,
  SUMMARY,
  ELIGIBILITY,
}

export default premadeContent
